import React, { useRef } from 'react';

import Button from '~/components/Button';

import ModalForm from './ModalForm';
import { Container, Head, Title } from './styles';
import Table from './Table';

const List = () => {
  const modalFormRef = useRef(null);
  const tableRef = useRef(null);

  const handleClickOpenModal = (data) => modalFormRef.current.openModal(data);

  const handleOnSave = () => tableRef.current.getRounds();

  return (
    <Container>
      <Head>
        <Title>Rodadas</Title>
        <Button label="Nova rodada" onClick={handleClickOpenModal} />
        <ModalForm ref={modalFormRef} onSave={handleOnSave} />
      </Head>
      <Table ref={tableRef} />
    </Container>
  );
};

export default List;
